import { gql } from '@apollo/client';
import type { SearchResultsOverview } from '../../../../../types';

export const SEARCH_OVERVIEW_QUERY = gql`
  query searchOverview($galleryId: ID!, $pageNumber: Int!, $tags: String!) {
    searchOverview(galleryId: $galleryId, pageNumber: $pageNumber, tags: $tags)
      @rest(
        type: "SearchResultOverview"
        method: "GET"
        path: "/galleries/api/galleries/{args.galleryId}/photos/_paginatedSearch?pageNumber={args.pageNumber}&tags={args.tags}"
        endpoint: "bff"
      ) {
      tags
      total
      resultsOverview {
        id
        hasMorePages
        pageNumber
        tag
        total
        type
        photos {
          id
          fileName
          tags
          status
          thumbnailFile {
            type
            uri
          }
          processedFile {
            type
            uri
          }
        }
      }
    }
  }
`;

export type SearchResultOverviewQueryVariables = {
  galleryId: string;
  pageNumber: number;
  tags: string;
};

export type SearchResultOverviewResponseData = {
  searchOverview: SearchResultsOverview;
};
